define('type/sharing/Serum.Sharing',['common/js/lib/Serum.Pubsub'], function(Pubsub){
  'use strict';

  function trackSharing(button){
    var share = button.getAttribute('data-share').split(':');
    Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
      category: 'Share',
      action: share[0],
      label: share[1]
    });
  }

  //Listen to bubbled click on data-share
  document.addEventListener('click', function(event){
    for(var el = event.target; el; el = el.parentElement){
      if(el.hasAttribute('data-share')){
        trackSharing(el);
        break;
      }
    }
  });
});

